<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/approvalEvaluationPlan/store/${inputs.id}`
            : `/accreditationtechnical/approvalEvaluationPlan/store/`
        "
      >
        <div class="row">
          <div class="col-sm-12" style="text-align: center">
            <h5 class="text-primary">¿Aprueba la documentación presentada?</h5>
            <a :href="inputs.file" class="btn btn-success" target="_blank">
              <i data-feather="file" class="pr-2" />
            </a>
            <br /><br />
            <div class="form-group">
              <app-input
                type="radio-buttons"
                v-model="inputs.options"
                :required="true"
                :list="list"
              />
            </div>
            <div class="form-group row align-items-center" v-if="inputs.options == 0">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Observaciones") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="textarea"
                v-if="inputs.options == '0'"
                v-model="inputs.observation_approval_evaluation"
              />
            </div>
          </div>
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationEmployeList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      request: {},
      modalId: "evaluation-testification-add-edit-modal",
      modalTitle: this.$t("add"),
      formInstruction1: [
        this.$t("Si existen observaciones escribelas en el siguiente recuadro"),
      ],
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },

  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("Revisión plan de evaluación");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.request["id"] = this.inputs.id;
      this.request["observation"] = this.inputs.observation_approval_evaluation;
      this.request["options"] = this.inputs.options;

      this.save(this.request);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.file = response.data.evaluation_plan_report.full_url;
      this.preloader = false;
    },
  },
};
</script>